// Preserve the saved Line 1.1 scroll-depth option without modifying vendor bundles.
if (!customElements.get('croma-scroll-to-top')) {
  customElements.define('croma-scroll-to-top', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.updateVisibility = () => {
        this.frame = null;
        const setting = this.getAttribute('data-scroll-depth');
        const distance = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const percent = distance > 0 ? Math.round(window.scrollY / distance * 100) : 0;
        const visible = setting === 'none' || (distance > 0 && percent >= Number(setting));
        this.toggleAttribute('xo-hidden', !visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
      };
      this.scheduleUpdate = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.updateVisibility);
      };
      const options = { passive: true, signal: this.controller.signal };
      window.addEventListener('scroll', this.scheduleUpdate, options);
      window.addEventListener('resize', this.scheduleUpdate, options);
      this.observer = new ResizeObserver(this.scheduleUpdate);
      this.observer.observe(document.body);
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
